import Vue from 'vue'
import VueI18n from 'vue-i18n'

import messages from './messages'
import dateTimeFormats from './dateTimeFormats'
import numberFormats from './numberFormats'

import { MetierLocalStorage } from 'modulelocalstorage'

Vue.use(VueI18n)

let locale = MetierLocalStorage.getLocale()
if (locale === null) {
  locale = navigator.language
  MetierLocalStorage.setLocale(locale)
}

const i18n = new VueI18n({
  fallbackLocale: 'fr-FR',
  locale: locale,
  messages,
  dateTimeFormats,
  numberFormats
  // silentTranslationWarn: true
})

export default i18n
